<template>
  <div>
    <v-card
      :loading="loading"
      flat
      class="mb-6"
      color="#badef9"
      bordered
      style="border: 1px solid #8eadc5"
    >
      <div class="d-flex flex-row flex-wrap align-center justify-space-between">
        <div class="text-h4 mx-4 my-4">
          Billing &amp; Coding - Clinical Examples
        </div>
        <!-- <v-spacer></v-spacer> -->
        <router-link
          to="/documentation/billing-and-coding-clinical-examples"
          class="ma-4"
        >
          See documentation</router-link
        >
      </div>
      <v-spacer> </v-spacer>
      <v-btn
        v-if="!$vuetify.breakpoint.smAndUp"
        @click="toggleExpandAll()"
        depressed
        rounded
        x-small
        class="ma-2"
        ><v-icon class="mr-2" x-small>{{
          expandAll ? "mdi-arrow-collapse" : "mdi-arrow-expand"
        }}</v-icon>
        {{ expandAll ? "Collapse" : "Expand" }} All</v-btn
      >
    </v-card>

    <div v-if="loading" class="d-flex flex-row flex-wrap width100p">
      <v-skeleton-loader
        type="card-heading"
        style="width: 100%; height: 40px"
      ></v-skeleton-loader>

      <div
        v-for="num in 20"
        :key="num"
        class="ma-2"
        :class="$vuetify.breakpoint.mdAndUp ? 'cardWidth' : 'width98'"
      >
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      </div>
    </div>

    <div v-else-if="cases && meta">
      <div
        v-for="(category, categorySlug) in meta.categories"
        :key="categorySlug"
        :id="categorySlug"
        class="mb-10"
      >
        <!-- <v-divider></v-divider> -->
        <div class="typeDiv justify-center">
          <div class="text-h6 d-flex align-start px-4 my-3">
            <!-- {{ categorySlug }} -->
            {{ category.title | titleize }}
            <v-spacer v-if="isMobile"></v-spacer>
            <!-- <v-btn
              text
              small
              color="primary"
        
              v-if="isMobile"
            >
              <span v-if="$vuetify.breakpoint.name == 'sm'">
                {{ expandAll[categorySlug] ? "Collapse" : "Expand" }} All
              </span>
              <v-icon small color="primary" class="ml-2"
                >mdi-arrow-{{
                  expandAll[categorySlug] ? "collapse" : "expand"
                }}</v-icon
              ></v-btn
            > -->
          </div>
          <!-- <v-divider></v-divider> -->
          <div class="d-sm-flex flex-row flex-wrap">
            <div
              v-for="caseItem in category.cases"
              :key="caseItem"
              :class="$vuetify.breakpoint.mdAndUp ? 'cardWidth' : 'width98'"
              :id="cases[caseItem].slug"
            >
              <coding-example-table
                :caseObj="cases[caseItem]"
                :id="cases[caseItem].slug"
                :expandAll="expandAll"
              ></coding-example-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- {{ meta }}
    <br /><br />
    {{ cases }} -->
    <!-- <page
        articleSlug="clinical-cases-coding-examples"
        :showHeader="false"
        :showSubscribeButton="true"
      ></page> -->
    <v-alert type="error" v-if="error" class="ma-4">
      There was an error downloading data. Please try again later.</v-alert
    >
  </div>
</template>

<script>
// import Page from "@/components/pagesStuff/Page";
import ApiServices from "@/services/ApiServices";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import UserMixin from "@/assets/js/UserMixin";
import CodingExampleTable from "@/components/referencesStuff/CodingExampleTable";

// import VueMarkdown from "@adapttive/vue-markdown";

// import ResponsiveTable from "@/components/pagesStuff/ResponsiveTable";
// import Name from "../dir/file";

export default {
  name: "CodingClinicalExamples",
  components: {
    // VueMarkdown,
    CodingExampleTable,
    // ResponsiveTable,
    // Page
  },
  mixins: [FiltersMixin, UserMixin],
  props: {},
  data: function () {
    return {
      api: "/billing/clinicalCases",
      expandAll: false,
      cases: null,
      meta: null,
      error: null,
      loading: false,
      imgPath: "https://www.eyedock.com/images/billingCodes/",
      filters: {
        item: null,
      },
    };
  },
  methods: {
    callApi() {
      this.loading = true;
      let params = this.isSubscribed ? "?subscriber=1" : "";
      ApiServices.genericApiCall(this.api, params)
        .then((response) => {
          this.cases = response.data.cases;
          this.meta = response.data.meta;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.checkForSlug();
          this.loading = false;
        });
    },
    checkForSlug() {
      let id = null;
      let category = this.filters.category;
      let item = this.filters.item;
      if (category) id = category;
      if (item) id = item;
      if (id) {
        this.goToId(id);
        // if (item) this.showSectionWithTag(id);
      }
    },
    setCategoryStore(item) {
      this.$store.dispatch("setModeAndDetail", {
        mode: null,
        detail: item,
      });
    },
    goToId(id) {
      //   console.log("goToId", id);
      this.$nextTick(() => {
        let el = document.getElementById(id);
        if (el) this.$vuetify.goTo(el, { offset: 20 });
      });
    },
    toggleExpandAll() {
      this.expandAll = !this.expandAll;
    },
  },
  computed: {
    isMobile: function () {
      return !this.$vuetify.breakpoint.mdAndUp;
    },

    storeDetail: function () {
      return this.$store.state.detail;
    },
  },

  watch: {
    // if a button is clicked in , it sets the "detail" in the store. This will be the item - if it changes, scroll to the correct element (set with id = #slug_name)
    storeDetail(val) {
      //   if (this.justScrolled) return; // don't scroll if the user just scrolled, though.
      this.filters.detail = val;
      if (val) {
        this.updateHashWithParamString("item=" + val);
        this.goToId(val);
      }
    },
    isSubscribed() {
      this.getData(); // reload the data if the subscriber status changes
    },
  },

  mounted() {
    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    let hashItem = this.hashValForKey("item");
    if (hashItem) this.expandAll = true;
    this.filters.item = hashItem;

    if (hashItem) this.setCategoryStore(hashItem);
    this.callApi();

    // window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener("scroll", this.throttledScroll);

    // this.getJSON("billingProtocols", "json"); // in the mixin
  },

  unmounted() {
    // window.removeEventListener("scroll", this.handleScroll);
  },

  metaInfo() {
    return {
      title: "EyeDock/Coding | Clinical Examples",
    };
  },
};
</script>

<style scoped>
.typeDiv {
  background-color: #f8fcff;
  border: 1px solid #bcbcbc;
  border-radius: 5px;
}
.sectionCard {
  border: 1px solid #bcbcbc !important;
}
.cardWidth {
  /* max-width: 50%;
    min-width: 350px; */
  width: 100%;
}
.cardTitle {
  background-color: #e8f5ff;
  border-bottom: 1px solid #bcbcbc !important;
}
.width98 {
  width: 98%;
}
table {
  border-collapse: collapse;
  background-color: #fff;
}
th,
td {
  vertical-align: top;
  padding: 4px 8px 0;
  border: 1px solid #e0e0e0;
}

tr:nth-child(odd) {
  background-color: #f3faff;
}
.sectionImg {
  width: 150px;
  max-height: 50px;
  /* border: 1px solid #a2d7ff; */
}
.sectionImg_sm {
  width: 90px;
  max-height: 30px;
  /* border: 1px solid #a2d7ff; */
}
</style>
